
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

/*
 * This component is based on this: https://stackoverflow.com/a/48431760/15288873
 * stackoverflow answer, therefore the event based handling instead of typical
 * Vue based data driven logic
 */
@Component({})
export default class BacPrefixedInput extends Vue {
  @Prop({ default: '' }) private prefix!: string;
  @Prop({ default: '' }) private initialValue!: string;

  mounted () {
    (this.$refs.inputElement as HTMLInputElement).value = this.prefix + this.initialValue

    const regex = new RegExp(this.prefix)
    this.addFormatter(this.$refs.inputElement as HTMLInputElement, this.regexPrefix(regex, this.prefix))
  }

  // Util function
  private addFormatter (input: HTMLInputElement, formatFn: Function) {
    let oldValue = input.value

    const handleInput = (event: Event|null) => {
      const result = formatFn(input.value, oldValue, event)
      if (typeof result === 'string') {
        input.value = result
      }

      oldValue = input.value

      // emit input value minus prefix (removed by char lenght) to parent
      this.$emit('input', input.value.substr(this.prefix.length))
    }

    handleInput(null)
    input.addEventListener('input', handleInput)
  }

  // Example implementation
  // HOF returning regex prefix formatter
  private regexPrefix (regex: RegExp, prefix: string): Function {
    return (newValue: string, oldValue: string) => {
      return regex.test(newValue) ? newValue : (newValue ? oldValue : prefix)
    }
  }
}
